/**
 * CoachPlaybook - GIF Viewer
 * Version: 0.7.0
 * Description: Displays an attached GIF for a play with play/pause and fullscreen
 */

import React, { useState } from 'react';

const GifViewer = ({ src, playName, onClose }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  if (!src) return null;

  /* ── Fullscreen modal overlay ── */
  const fullscreenOverlay = isFullscreen ? (
    <div
      onClick={() => setIsFullscreen(false)}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.92)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      {/* Header bar */}
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 24px',
          background: 'linear-gradient(180deg, rgba(0,0,0,0.6) 0%, transparent 100%)',
        }}
      >
        <span style={{ color: '#f1f5f9', fontSize: 16, fontWeight: 600 }}>
          {playName || 'Play GIF'}
        </span>
        <button
          onClick={() => setIsFullscreen(false)}
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            border: '1px solid rgba(255,255,255,0.2)',
            backgroundColor: 'rgba(255,255,255,0.1)',
            color: '#f1f5f9',
            fontSize: 18,
            fontWeight: 700,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          X
        </button>
      </div>

      {/* GIF image */}
      <img
        src={src}
        alt={playName || 'Play GIF'}
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '90vw',
          maxHeight: '85vh',
          objectFit: 'contain',
          borderRadius: 8,
          boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
        }}
      />
    </div>
  ) : null;

  /* ── Card viewer ── */
  return (
    <>
      {fullscreenOverlay}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 100,
          backgroundColor: '#1e293b',
          borderRadius: 12,
          border: '1px solid #334155',
          boxShadow: '0 12px 40px rgba(0,0,0,0.5)',
          overflow: 'hidden',
          maxWidth: '80%',
          maxHeight: '80%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px 16px',
            borderBottom: '1px solid #334155',
            backgroundColor: '#0f172a',
          }}
        >
          <span style={{ color: '#f1f5f9', fontSize: 14, fontWeight: 600 }}>
            {playName || 'Play GIF'}
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={() => setIsFullscreen(true)}
              style={{
                padding: '4px 12px',
                borderRadius: 6,
                border: '1px solid #475569',
                backgroundColor: 'transparent',
                color: '#94a3b8',
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.15s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#334155';
                e.currentTarget.style.color = '#f1f5f9';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#94a3b8';
              }}
            >
              Fullscreen
            </button>
            <button
              onClick={onClose}
              style={{
                width: 28,
                height: 28,
                borderRadius: 6,
                border: '1px solid #475569',
                backgroundColor: 'transparent',
                color: '#94a3b8',
                fontSize: 14,
                fontWeight: 700,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.15s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#7f1d1d';
                e.currentTarget.style.color = '#fca5a5';
                e.currentTarget.style.borderColor = '#991b1b';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#94a3b8';
                e.currentTarget.style.borderColor = '#475569';
              }}
            >
              X
            </button>
          </div>
        </div>

        {/* GIF */}
        <div style={{ padding: 12, display: 'flex', justifyContent: 'center', overflow: 'auto' }}>
          <img
            src={src}
            alt={playName || 'Play GIF'}
            style={{
              maxWidth: '100%',
              maxHeight: '60vh',
              objectFit: 'contain',
              borderRadius: 6,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default GifViewer;
